// extracted by mini-css-extract-plugin
export default {"button":"vvi7kG","studio2":"D0dnQz","animatedIcon":"TqIvDr","content":"StIhPb"};